import React from 'react';
import styled from 'styled-components';

export const StyledText = styled(({ children, ...rest }) => <span {...rest}>{children}</span>)`
  color: ${({ theme }) => theme.colors.complementary.veryDarkCyan};
  margin: 20px 0px;
`;
